<template>
  <div class="c_video_banner c_text--center c_box--break_out">
    <MediaImage
      v-if="image && !backgroundVideo[0]"
      background
      class="c_video_banner__image"
      :sources="formatSources(image)"
      :alt="image.title"
    />
    <!-- <div class="c_video_banner__background"> -->
    <video
      v-if="backgroundVideo[0]"
      :id="backgroundVideo[0].id"
      :ref="backgroundVideo[0].id"
      class="c_video_banner__video"
      autoplay
      muted
      loop
      playsinline
      :poster="image.url"
    >
      <source :src="backgroundVideo[0].url" type="video/mp4" />
    </video>
    <!-- <video :src="backgroundVideo[0].url" type="video/mp4" loop /> -->
    <!-- </div> -->
    <Button
      @onClick="image.videoId ? $refs.videoBannerOverlay.show() : null"
      class="c_video_banner__content c_text--white"
      unstyle
      reset
      :aria-label="$t('Open media in popup overlay')"
    >
      <IconSVG
        class="c_video_banner__content__icon"
        v-if="image.videoId"
        handle="media_play"
        aria-hidden="true"
      ></IconSVG>
      <h3 v-if="header" class="c_header c_header--1 c_text--graphik_bold" v-html="header"></h3>
      <div class="c_text c_header--3" v-if="text" v-html="text"></div>
    </Button>
    <div class="c_video_banner__image__overlay"></div>
    <Overlay
      class="c_video_banner__overlay"
      ref="videoBannerOverlay"
      theme="full"
      :show-close-button="true"
      v-if="image.videoId"
    >
      <div class="c_box--pos--relative c_video_banner__overlay__video">
        <MediaVideo
          v-if="image.videoId"
          loading="eager"
          :source="image.videoSource"
          :video-id="image.videoId"
          autoplay
          playsinline
        ></MediaVideo>
      </div>
    </Overlay>
  </div>
</template>

<script>
import Button from 'Components/button/Button.vue';
import IconSVG from 'Components/icon_svg/IconSVG.vue';
import Overlay from 'Components/overlay/Overlay.vue';
import MediaImage from 'Components/image/MediaImage.vue';
import MediaVideo from 'Components/video/MediaVideo.vue';
export default {
  components: {
    Button,
    IconSVG,
    MediaImage,
    MediaVideo,
    Overlay,
  },
  data() {
    return {};
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
    imageOptimizedFields: {
      type: Array,
      required: true,
    },
    backgroundVideo: Array,
    header: String,
    text: String,
  },
  methods: {
    formatSources(image) {
      const returnArray = []; // originally let
      for (let i = 0; i < this.imageOptimizedFields.length; i++) {
        returnArray.push({ srcset: image[this.imageOptimizedFields[i]].srcsetWebp, type: 'webp' });
        returnArray.push({ srcset: image[this.imageOptimizedFields[i]].srcset });
      }
      return returnArray;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
@mixin absolute_fill() {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
}

.c_video_banner {
  $self: &;
  display: block;
  overflow: hidden;
  position: relative;
  padding: 15% 0;
  @at-root #{$self}__image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    // background-position: center;
    @at-root #{&}__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color_black_raw, 0.5);
    }
  }
  @at-root #{$self}__video {
    position: absolute;
    left: 50%;
    top: 50%;
    min-width: 100%;
    min-height: 100%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    z-index: 0;
    object-fit: cover;

    /* background-position: center;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0; */
    // transform: translate(-50%, -50%);
    // overflow: hidden;
    // background-position: center;
    @at-root #{&}__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color_black_raw, 0.5);
    }
  }

  @at-root #{$self}__background {
    $background: &;
    @include absolute_fill();
    @at-root #{$background}__overlay {
      @include absolute_fill();
      background-color: black;
      opacity: var(--opacity);
      z-index: 2;
    }
    @at-root #{$background}__overlay.light {
      background-color: white;
    }
    @at-root #{$background}__visual {
      $visual: &;
      @include absolute_fill();
      background-color: transparent;
      z-index: 1;
      background-size: cover;
      background-position: center;
      overflow-x: hidden;
      overflow-y: hidden;
      /*c_hero_banner__background__visual__video{  tab in twice*/
      @at-root #{$visual}__video {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        z-index: -100;
        -ms-transform: translateX(-50%) translateY(-50%);
        -moz-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        background-size: cover;
        overflow-x: hidden;
      }
    }
  }

  @at-root #{$self}__content {
    $content: &;
    margin: 0 auto;
    position: relative;
    z-index: 50;
    color: $color_white;
    width: 80%;

    @at-root #{&}__icon {
      max-width: px_to_rem(50);
      max-height: px_to_rem(50);
      margin: 0 auto;
      margin-bottom: px_to_rem(15);
      @include mq($mq_sm_to_md) {
        max-width: px_to_rem(75);
        max-height: px_to_rem(75);
        margin-bottom: px_to_rem(30);
      }
      #{$content}:hover &,
      #{$content}:focus & {
        color: $color_yellow;
      }
    }
  }

  @at-root #{$self}__overlay {
    @at-root #{&}__video {
      width: 90vw;
      max-width: 100%;
      overflow: hidden;
      @include mq($mq_sm_to_md) {
        width: 70vw;
      }
      @include mq($mq_md_to_lg) {
        width: px_to_rem(800);
      }
    }
  }
}
</style>
